"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintableResidentialRoadIcon = PrintableResidentialRoadIcon;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PrintableResidentialRoadIcon({
  color,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_renderer.Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement(_renderer.Path, {
    d: "M23.977 12.431c0.006-0.144 0.023-0.284 0.023-0.429 0-6.616-5.384-12.002-12-12.002s-12 5.385-12 12.002c0 0.146 0.017 0.285 0.022 0.429l-0.022 0.023 0.024 0.023c0.252 6.396 5.518 11.524 11.976 11.524s11.726-5.13 11.976-11.527l0.024-0.021-0.023-0.021zM12 1.081c5.809 0 10.56 4.561 10.889 10.29l-6.303-6.122-4.596 4.502-4.632-4.502-6.246 6.114c0.333-5.724 5.082-10.282 10.888-10.282zM12 22.92c-5.721 0-10.419-4.424-10.875-10.030l6.237-6.099 3.843 3.732 0.787 0.77 4.601-4.5 6.282 6.101c-0.456 5.604-5.154 10.027-10.875 10.027zM16.614 8.019l-4.614 4.614-4.617-4.614-4.614 4.614v4.617h3.655v-3.697h1.92v3.697h7.328v-3.697h1.868v3.697h3.691v-4.617z",
    fill: color
  }));
}